/** Sons d’appel Chat — Ringtone / calling (boucle) + Smartphone Open / Close (one-shot). */

const RINGTONE_URL = `${import.meta.env.BASE_URL}sound/Ringtone.wav`;
const CALLING_URL = `${import.meta.env.BASE_URL}sound/calling.mp3`;
const OPEN_URL = `${import.meta.env.BASE_URL}sound/${encodeURIComponent("Smartphone Open.wav")}`;
const CLOSE_URL = `${import.meta.env.BASE_URL}sound/${encodeURIComponent("Smartphone Close.wav")}`;

let ringtoneEl: HTMLAudioElement | null = null;
let callingEl: HTMLAudioElement | null = null;
let closeLockUntil = 0;
let openLockUntil = 0;
let oneShotEl: HTMLAudioElement | null = null;

function ensureLoop(url: string, existing: HTMLAudioElement | null): HTMLAudioElement {
  if (existing) return existing;
  const el = new Audio(url);
  el.loop = true;
  el.preload = "auto";
  el.volume = 0.85;
  return el;
}

function stopOneShot(): void {
  if (!oneShotEl) return;
  try {
    oneShotEl.pause();
    oneShotEl.currentTime = 0;
  } catch {
    /* ignore */
  }
  oneShotEl = null;
}

function stopLoopHard(el: HTMLAudioElement | null): void {
  if (!el) return;
  try {
    el.pause();
    el.currentTime = 0;
  } catch {
    /* ignore */
  }
}

export function stopChatCallRingtone(): void {
  stopLoopHard(ringtoneEl);
}

export function stopChatCallCalling(): void {
  stopLoopHard(callingEl);
}

export function stopAllChatCallSounds(): void {
  stopChatCallRingtone();
  stopChatCallCalling();
}

/** Coupe immédiatement sonnerie / calling (sans toucher Open/Close en cours). */
function cutRingTones(): void {
  stopChatCallRingtone();
  stopChatCallCalling();
}

function playOneShotNow(url: string, volume = 0.95): void {
  try {
    stopOneShot();
    const el = new Audio(url);
    el.loop = false;
    el.volume = volume;
    el.preload = "auto";
    oneShotEl = el;
    el.addEventListener(
      "ended",
      () => {
        if (oneShotEl === el) oneShotEl = null;
      },
      { once: true }
    );
    // play() synchrone au geste clic quand possible — pas de setTimeout.
    void el.play().catch((err) => {
      console.warn("[chat-call-sound] play blocked", url, err);
    });
  } catch (err) {
    console.warn("[chat-call-sound] create failed", url, err);
  }
}

export function playChatCallRingtone(): void {
  stopChatCallCalling();
  stopOneShot();
  ringtoneEl = ensureLoop(RINGTONE_URL, ringtoneEl);
  void ringtoneEl.play().catch(() => undefined);
}

export function playChatCallCalling(): void {
  stopChatCallRingtone();
  stopOneShot();
  callingEl = ensureLoop(CALLING_URL, callingEl);
  void callingEl.play().catch(() => undefined);
}

/**
 * Décrochage — coupe la sonnerie/calling puis joue Smartphone Open.
 * À appeler au moment exact où l’appel passe « en communication ».
 */
export function playChatCallOpen(): void {
  const now = Date.now();
  if (now < openLockUntil) return;
  openLockUntil = now + 1800;
  cutRingTones();
  playOneShotNow(OPEN_URL, 0.95);
}

/**
 * Raccrochage / refus — coupe tout puis joue Smartphone Close.
 * À appeler synchrone au clic quand possible.
 */
export function playChatCallClose(): void {
  const now = Date.now();
  if (now < closeLockUntil) return;
  closeLockUntil = now + 1800;
  cutRingTones();
  playOneShotNow(CLOSE_URL, 0.95);
}
